module.exports = __webpack_public_path__ + "static/media/Savings.b31c551e.png";